import React, { useEffect, useState } from "react";
import { GeneralContainer } from "./EventsFeedbackContainer.styled";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import FeedbackComponent from "../../components/FeedbackComponent/FeedbackComponent";

const EventsFeedbackContainer = ({ events, handleSaveFeedback }) => {
  const [event, setEvent] = useState({});
  const [arrayImageRating, setArrayImageRating] = useState([]);
  const [eventRating, setEventRating] = useState(0);

  useEffect(() => {
    if (events.length > 0) {
      setEvent(events[0]);
      setEventRating(0);
    }
  }, [events]);

  useEffect(() => {
    setRatingWidget();
  }, [eventRating]);

  const handleRatingClick = (e) => {
    setEventRating(e?.id ? e.id : e?.currentTarget?.id);
  };

  const handleSendFeedback = (comments) => {
    handleSaveFeedback(event.idEvent, comments, parseInt(eventRating));
  };
  const setRatingWidget = () => {
    let arrRating = [];
    arrRating = [1, 2, 3, 4, 5].map((data, i) => {
      return (
        <StarRoundedIcon
          key={data}
          id={data}
          className="icon-selected-Survey-answer ImageRating"
          style={{
            fill:
              eventRating == 0
                ? "#b7b7b7"
                : eventRating >= data
                ? "#ffc502"
                : "#b7b7b7",
            cursor: "pointer",
          }}
          onClick={handleRatingClick}
        ></StarRoundedIcon>
      );
    });
    setArrayImageRating([...arrRating].reverse());
  };

  return (
    <GeneralContainer>
      {event?.idEvent && (
        <FeedbackComponent
          arrayImageRating={arrayImageRating}
          eventName={event?.eventName}
          eventRating={eventRating}
          handleSendFeedback={handleSendFeedback}
        />
      )}
    </GeneralContainer>
  );
};

export default EventsFeedbackContainer;
